import { render } from "./Holo_Word.vue?vue&type=template&id=22034f28"
import script from "./Holo_Word.vue?vue&type=script&lang=js"
export * from "./Holo_Word.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__